//koristi se login template

import BaseParagraph from "../../baseComponents/baseParagraph";
import BaseButton from "../../baseComponents/baseButton";
import LoginTemplate from "../loginStack/LoginTemplate.js";
import { useEffect, useRef, useState } from "react";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../store/slices/loginSlice.js";
import { useDispatch } from "react-redux";
import routes from "../routes";
import { useLocation } from "react-router-dom";
import useColors from "../../customHooks/useColors";

const PageNotFoundView = ({
  afterLoginRoutesPath = [],
  loginRoutesPath = [],
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const mainPaths = routes.map((route) => route.path);
  const isInMainPaths = mainPaths.includes(currentPath);

  const dispatch = useDispatch();

  //theme
  const [currentColors] = useColors();

  //refs
  const mainButtonRef = useRef();

  //methods

  const goBackToRoot = () => {
    dispatch(loginActions.logout());
    window.location.href = "/";
  };

  //styles
  const styles = {
    messageContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    errorNumber: {
      fontSize: "130px",
      color: currentColors.primary,
    },
    pageNotFound: {
      fontSize: "40px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    pageNotFoundMessage: {
      fontSize: "24px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    button: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "0.5em",
      paddingBottom: "0.5em",
    },
  };

  return (
    <LoginTemplate
      showPickers={false}
      focusElement={mainButtonRef}
      autoRelogin
      afterLoginRoutesPath={afterLoginRoutesPath}
      loginRoutesPath={loginRoutesPath}
    >
      <div style={styles.messageContainer}>
        {!isInMainPaths && (
          <BaseParagraph bold style={styles.errorNumber} translate={false}>
            404
          </BaseParagraph>
        )}
        <BaseParagraph bold style={styles.pageNotFound}>
          pageNotFound
        </BaseParagraph>
        <BaseParagraph style={styles.pageNotFoundMessage}>
          pageNotFoundMessage
        </BaseParagraph>
        <BaseButton
          style={styles.button}
          onClick={goBackToRoot}
          innerRef={mainButtonRef}
        >
          homePage
        </BaseButton>
      </div>
    </LoginTemplate>
  );
};

export default PageNotFoundView;
